import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Environment } from 'src/environments/environment.utils';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentWrapper {
  getEnvironment(): Environment {
    return environment;
  }
}
